import { Input, Label } from "reactstrap";

const ItemFilterBar = ({ label, options, onChange, className }) => {
  return (
    <div className={className}>
      <Label className="p-2 bg-transparent">{label}</Label>
      <Input
        className={"bg-transparent"}
        type="select"
        placeholder="Pilih "
        onChange={onChange}
      >
        <option value={""} className="text-secondary">
          Semua
        </option>
        {options.map((option) => (
          <option>{option.value}</option>
        ))}
      </Input>
    </div>
  );
};

export default ItemFilterBar;
